import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { path } from 'ramda'

import useShowModal from '../../../hooks/use-show-modal'
import { useOneWaySubscriptionChange } from '../../../hooks/useOneWaySubscriptionChange'
import { usePlanChangeFlag } from '../../../hooks/usePlanChange'
import { segmentTrackCancelJourney } from '../../../segment/segment-track'
import { modalContent } from '../../../modules/shared/subscription-constants'
import { CANCEL_JOURNEY_BUTTONS } from '../../../segment/constants'
import { MODALS, CANCEL_SUBSCRIPTION_SCREENS } from '../../../constants'
import Button from '../../button'
import styles from '../cancel-subscription.css'

function ChangePlanCard({ activeSubscription }) {
  const showModal = useShowModal()
  const oneWayChangeDirection = useOneWaySubscriptionChange(activeSubscription.manageSubsOptions)
  const getPlanDetails = usePlanChangeFlag()

  const currentSubscription = path(['currentSubscription'], activeSubscription)

  const planContent = {
    basic: {
      sku: getPlanDetails.basic.sku,
      header: 'Change plan',
      copy: 'If your plan isn’t working for you anymore, you can easily switch to a plan better for you.',
      cta: 'COMPARE PLANS',
      hasBadge: false,
      preSelectedPlan: null
    },
    standard: {
      sku: getPlanDetails.standard.sku,
      header: `Save now by switching to ${getPlanDetails.basic.title}`,
      copy: `Neon's best. Just for less. $${getPlanDetails.basic.price}${getPlanDetails.basic.unit}.`,
      cta: `CHANGE TO ${getPlanDetails.basic.type}`,
      hasBadge: true,
      preSelectedPlan: getPlanDetails.basic.title
    },
    legacy: {
      sku: getPlanDetails.legacy.sku,
      header: `Save now by switching to ${getPlanDetails.basic.title}`,
      copy: `Neon's best. Just for less. $${getPlanDetails.basic.price}${getPlanDetails.basic.unit}.`,
      cta: `CHANGE TO ${getPlanDetails.basic.type}`,
      hasBadge: true,
      preSelectedPlan: getPlanDetails.basic.title
    },
    annual: {
      sku: getPlanDetails.annual.sku,
      header: `Save now by switching to ${getPlanDetails.standard.title}`,
      copy: `Neon's best. Just for less. $${getPlanDetails.standard.price}${getPlanDetails.standard.unit}.`,
      cta: `CHANGE TO ${getPlanDetails.standard.type}`,
      hasBadge: true,
      preSelectedPlan: getPlanDetails.standard.title
    }
  }

  const {
    header,
    copy,
    cta,
    hasBadge,
    preSelectedPlan
  } = Object.values(planContent).find(plan => plan.sku === currentSubscription.sku)

  const onClickHandler = () => {
    showModal(MODALS.qsParams.addSubscription, {
      content: modalContent.selection,
      currentSubscription: currentSubscription.name,
      oneWayChangeDirection,
      hasRecurringVouchers: !!(activeSubscription.recurringVouchers && activeSubscription.recurringVouchers.length),
      preSelectedPlan
    })

    // Track cancel journey event
    segmentTrackCancelJourney({
      step: CANCEL_SUBSCRIPTION_SCREENS.CANCEL_SUBSCRIPTION_LANDING.name,
      buttonClicked: CANCEL_JOURNEY_BUTTONS.COMPARE_PLANS
    })
  }

  return (
    <div
      className={
        classnames(styles.section, styles.card, styles.reduceTopMargin)
      }
    >
      {hasBadge && (
        <span
          className={
            classnames(styles.badge, styles.whiteBadge)
          }
        >
          BEST VALUE
        </span>
      )}
      <div className={styles.header}>
        {header}
      </div>
      <div className={styles.copy}>
        {copy}
      </div>
      <Button
        className={styles.button}
        text={cta}
        onClick={onClickHandler}
        darkBGSecondary
      />
    </div>
  )
}

ChangePlanCard.propTypes = {
  activeSubscription: PropTypes.oneOfType([PropTypes.object]).isRequired
}

export default ChangePlanCard
